import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { showAuthenticationPopup, setAuthenticationPopupShowSignupPanel } from '../actions/common';
import LoginForm from './auth/auth-popup-form/LoginForm';
import SignupForm from './auth/auth-popup-form/SignupForm';
import ForgotPasswordForm from './form/ForgotPasswordForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class AuthenticationPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            forgotPasswordVisible: false,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.authenticated === false && this.props.authenticated === true) {
            this.props.showAuthenticationPopup(false);
        }
        if (!_.isEqual(prevProps.match, this.props.match)) {
            this.props.showAuthenticationPopup(false);
        }
    }

    render() {
        const { visible, showSignup, authenticated } = this.props;

        if (visible && !authenticated) {
            return (
                <div className="auth-popup-backdrop">
                    <div className="auth-popup-container">
                        <div className="auth-popup-content" onClick={(e) => e.stopPropagation()}>
                            {/* Close Button */}
                            <button
                                className="auth-popup-close"
                                onClick={() => this.props.showAuthenticationPopup(false)}
                                aria-label="Close popup"
                            >
                                <FontAwesomeIcon icon={["fas", "times"]} />
                            </button>

                            {/* Popup Header */}
                            <div className="auth-popup-header">
                                <h2 className="auth-popup-title">
                                    {showSignup ? 'สมัครสมาชิก' : 'เข้าสู่ระบบ'}
                                </h2>
                                <p className="auth-popup-subtitle">
                                    {showSignup
                                        ? 'สร้างบัญชีใหม่เพื่อเริ่มต้นการช้อปปิ้ง'
                                        : 'เข้าสู่ระบบเพื่อเข้าถึงบัญชีของคุณ'
                                    }
                                </p>
                            </div>

                            {/* Form Content */}
                            <div className="auth-popup-body">
                                {!showSignup ? (
                                    <LoginForm
                                        showSignup={(v) => { this.setState({ showSignup: v }) }}
                                        onForgotClick={() => this.setState({ forgotPasswordVisible: true })}
                                    />
                                ) : (
                                    <SignupForm
                                        showSignup={(v) => { this.setState({ showSignup: v }) }}
                                    />
                                )}
                            </div>

                            {/* Switch Mode */}
                            <div className="auth-popup-footer">
                                {!showSignup ? (
                                    <div className="auth-switch-mode">
                                        <span className="auth-switch-text">
                                            ยังไม่สมัครสมาชิก{' '}
                                            <button
                                                className="auth-switch-link"
                                                onClick={() => this.props.setAuthenticationPopupShowSignupPanel('signup')}
                                            >
                                                คลิกที่นี่ค่ะ
                                            </button>
                                        </span>
                                    </div>
                                ) : (
                                    <div className="auth-switch-mode">
                                        <span className="auth-switch-text">
                                            เป็นสมาชิกอยู่แล้ว{' '}
                                            <button
                                                className="auth-switch-link"
                                                onClick={() => this.props.setAuthenticationPopupShowSignupPanel('login')}
                                            >
                                                คลิกที่นี่ค่ะ
                                            </button>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Forgot Password Modal */}
                    {this.state.forgotPasswordVisible && (
                        <ForgotPasswordForm
                            closePopup={() => { this.setState({ forgotPasswordVisible: false }) }}
                        />
                    )}
                </div>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        visible: state.common.show_login,
        showSignup: state.common.authPopupPanel === 'signup',
    }
}

export default connect(mapStateToProps, { showAuthenticationPopup, setAuthenticationPopupShowSignupPanel })(AuthenticationPopup)